import { render } from "./MedicarePayor.vue?vue&type=template&id=1bad0ada&ts=true"
import script from "./MedicarePayor.vue?vue&type=script&lang=ts"
export * from "./MedicarePayor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__